import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { DialogHomeTutorialComponent } from '../../shared/dialog-home-tutorial/dialog-home-tutorial.component';
import { NgIf } from '@angular/common';
import { FeatureFlagService } from '../../services/feature-flag/feature-flag.service';
import { AnosReferenciasService } from '../../services/anos-referencias/anos-referencias.service';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [RouterModule, NgIf],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
})
export class HomeComponent implements OnInit {
  constructor(
    public dialog: MatDialog,
    public featureFlagService: FeatureFlagService,
    private anosReferenciasService: AnosReferenciasService,
  ) {}

  ngOnInit(): void {
    if (this.featureFlagService.funcionalidadeHabilitada('937-consumo-api-datas')) {
      this.anosReferenciasService.carregarAnosReferencias().subscribe();
    }
  }

  abrirDialog(simularLink?: string) {
    const data: { simularLink?: string } = {};
    if (simularLink) {
      data.simularLink = simularLink;
    }

    this.dialog.open(DialogHomeTutorialComponent, {
      panelClass: 'dialog-home',
      data: data,
    });
  }
}
